var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_6.7.3._Vista_general:_Paciente-_Acceso_a_la_consulta_en_estados:_Caducada",
    "data-name": "6.7.3. Vista general: Paciente- Acceso a la consulta en estados: Caducada",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.863,
    height: 135.864,
    viewBox: "0 0 135.863 135.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M135.864,67.932A67.932,67.932,0,0,0,19.9,19.9a67.952,67.952,0,0,0,66.619,113.39,35.978,35.978,0,0,0,46.772-46.772,68,68,0,0,0,2.577-18.583ZM67.932,127.9A59.971,59.971,0,0,1,25.526,25.526,59.971,59.971,0,0,1,127.9,67.932a60.521,60.521,0,0,1-.622,8.657A36.275,36.275,0,0,0,119.9,70c.027-.689.043-1.38.043-2.067a52.01,52.01,0,1,0-52.01,52.01c.688,0,1.378-.016,2.067-.043a36.274,36.274,0,0,0,6.589,7.381,60.49,60.49,0,0,1-8.657.623ZM63.9,99.884a35.812,35.812,0,0,0,2.079,12.052,43.843,43.843,0,0,1-26.241-10.184l6.343-6.343-5.629-5.629-6.343,6.343a43.852,43.852,0,0,1-10.048-24.21h9.367V63.951H24.064A43.854,43.854,0,0,1,34.112,39.741l6.609,6.609,5.629-5.629-6.609-6.609A43.852,43.852,0,0,1,63.951,24.064V69.533l7.723,8.042A35.8,35.8,0,0,0,63.9,99.884ZM77.276,71.916,71.912,66.33V24.064a44.113,44.113,0,0,1,40.024,41.918,35.926,35.926,0,0,0-34.66,5.934ZM99.884,127.9A28.019,28.019,0,1,1,127.9,99.884,28.051,28.051,0,0,1,99.884,127.9Z",
    transform: "translate(0 0)",
    fill: "#f7b500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M366.105,329.616l1.651-24.331h-9.9l1.65,24.331Z",
    transform: "translate(-262.895 -224.276)",
    fill: "#f7b500"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 4.553,
    cy: 4.553,
    r: 4.553,
    transform: "translate(95.338 110.447)",
    fill: "#f7b500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpired);
export default __webpack_public_path__ + "static/media/icon-expired.29a922b2fdf15245e7fbc3cb2eda0952.svg";
export { ForwardRef as ReactComponent };